import {
  type DataConnectorJob,
  DataConnectorJobType,
  type DataSourceType,
} from "@decentriq/graphql/dist/types";
import { Stack } from "@mui/joy";
import { type MRT_TableInstance } from "material-react-table";
import { memo, useCallback } from "react";
import { EntitiesSearch, ExportAsCsvButton } from "components/base";
import { DatasetImportButton } from "features/datasets/components";
import { dataSourceTypePresentation } from "features/datasets/models";

interface ExternalConnectionsToolbarProps {
  onSearchChange: (value: string) => void;
  searchValue: string;
  hasData: boolean;
  table: MRT_TableInstance<DataConnectorJob>;
}

const getHeaders = () => [
  "Imported from",
  "Name",
  "Started at",
  "Status",
  "Type",
];

const ExternalConnectionsToolbar = memo<ExternalConnectionsToolbarProps>(
  ({ onSearchChange, searchValue, table, hasData }) => {
    const getRows = useCallback(() => {
      return table.getPaginationRowModel().rows.map((row) => {
        const { name, status, createdAt, sourceType, type } = row.original;
        const formattedDate = createdAt
          ? new Date(createdAt).toLocaleString()
          : "-";
        const isExport = [
          DataConnectorJobType.ExportDataset,
          DataConnectorJobType.ExportDcrJobResult,
        ].includes(type);
        return [
          dataSourceTypePresentation[sourceType as DataSourceType],
          name,
          formattedDate,
          status,
          isExport ? "Export" : "Import",
        ];
      });
    }, [table]);
    return (
      <Stack
        direction="row"
        justifyContent="space-between"
        spacing={2}
        width="100%"
      >
        <Stack sx={{ minWidth: "280px" }}>
          <EntitiesSearch
            onChange={(event) => onSearchChange(event.target.value)}
            onClear={() => onSearchChange("")}
            placeholder="Search datasets"
            value={searchValue}
          />
        </Stack>
        <Stack direction="row">
          {hasData ? (
            <ExportAsCsvButton
              fileName="external-connections.csv"
              getHeaders={getHeaders}
              getRows={getRows}
            />
          ) : null}
          <DatasetImportButton />
        </Stack>
      </Stack>
    );
  }
);

export default ExternalConnectionsToolbar;
